import {
    MAIL_DEEPLINK_URL_BASE,
    COMPOSE_ROUTE,
    REPLY_ALL_ROUTE,
    REPLY_ROUTE,
} from './deeplinkConstants';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { formatUrl } from './formatUrl';
import * as querystring from 'querystring';
import { MailTo, serializeMailTo } from './MailTo';

export function getMailComposeDeeplink(): string {
    return formatUrl(MAIL_DEEPLINK_URL_BASE, COMPOSE_ROUTE, getHostLocation().search);
}

export function getMailComposeReplyDeeplink(replyAll: boolean): string {
    const route = COMPOSE_ROUTE + '/' + (replyAll ? REPLY_ALL_ROUTE : REPLY_ROUTE);
    return formatUrl(MAIL_DEEPLINK_URL_BASE, route, getHostLocation().search);
}

export function getMailToComposeDeeplink(mailTo: MailTo): string {
    if (!(mailTo.to && mailTo.to.smtpAddress)) {
        return '';
    }

    const newSearch = querystring.parse(getHostLocation().search.substr(1));
    newSearch.mailtouri = serializeMailTo(mailTo);
    return formatUrl(MAIL_DEEPLINK_URL_BASE, COMPOSE_ROUTE, '?' + querystring.stringify(newSearch));
}
